<template>
  <div class="renderPage te-container" :class="{ 'theme--dark': $vuetify.theme.dark }">
    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="te-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-ticket-percent-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase te-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Tiquetes Electrónicos
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="te-btn font-weight-bold" @click="validarLicencia()">
        <v-icon left small>mdi-plus</v-icon> Nuevo Tiquete
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="te-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="auto" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3 pt-2 pb-3">
        <v-row dense align="center">
          <v-col cols="12" sm="3" md="3">
            <v-dialog
              ref="dialog"
              v-model="dateModal"
              :return-value.sync="dates"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datesFormat"
                  label="Rango de fechas"
                  prepend-inner-icon="mdi-calendar"
                  readonly outlined dense hide-details
                  class="te-search"
                  v-bind="attrs" v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range scrollable color="primary">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModal = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(dates); getData();">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por cliente, código o estado..."
              single-line hide-details outlined dense
              class="te-search"
            ></v-text-field>
          </v-col>
          <v-spacer />
          <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="te-table"
        :loading="loading"
        @click:row="editItem"
        style="cursor:pointer"
      >

        <template v-slot:[`item.estadoHacienda`]="{ item }">
          <v-chip
            small
            :color="getEstadoColor(item.estadoHacienda)"
            class="font-weight-bold"
            text-color="white"
          >
            {{ item.estadoHacienda }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalComprobante`]="{ item }">
             <span class="font-weight-bold">{{ (item.totalComprobante).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-eye-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-ticket-outline</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No se encontraron tiquetes en este periodo.</p>
            <v-btn color="primary" depressed small @click="getData()">Reintentar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- FORM DRAWER - "SUPER DRAWER" PARA TIQUETES -->
    <v-navigation-drawer
      v-model="drawerForm"
      fixed right temporary
      :width="$vuetify.breakpoint.mdAndUp ? 'calc(100% - 290px)' : '100%'"
      class="te-drawer"
      stateless
    >
      <div class="d-flex flex-column fill-height">
        <!-- HEADER DEL DRAWER -->
        <div class="te-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'te-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">mdi-ticket-percent-outline</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex === -1 ? 'Nuevo Tiquete Electrónico' : 'Detalles de Tiquete' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">
              {{ editedItem.codigoFact ? 'Comprobante #' + editedItem.codigoFact : 'Generando nuevo documento...' }}
              <v-chip v-if="editedIndex > -1 && editedItem.estadoHacienda" x-small dark outlined class="ml-2 font-weight-black" style="height:18px">
                {{ editedItem.estadoHacienda }}
              </v-chip>
            </div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- CONTENIDO DEL DRAWER -->
        <div class="flex-grow-1 overflow-y-auto px-2 py-2 bg-light">
          <v-form v-model="valid" ref="form">
            <v-expansion-panels v-model="activePanels" multiple class="modern-panels">
              
              <!-- SECCIÓN 1: SELECCIÓN DE CLIENTE (OPCIONAL EN TIQUETE) -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-account-search-outline</v-icon>
                  Información del Cliente
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="# Código Cliente"
                        v-model="editedItem.clienteCod"
                        outlined dense hide-details
                        @input="iconVisible = true"
                        :disabled="!incluirValid"
                      >
                        <template v-slot:append>
                          <v-icon color="primary" @click="BuscarClienteCodigo" v-if="iconVisible && incluirValid">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Cédula / Identificación"
                        v-model="editedItem.clienteCedula"
                        outlined dense hide-details
                        @input="iconVisibleCedula = true"
                        :disabled="!incluirValid"
                      >
                        <template v-slot:append>
                          <v-icon color="primary" @click="BuscarClienteCedula" v-if="iconVisibleCedula && incluirValid">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="text-center">
                      <v-btn color="primary" icon large @click="mostrarBuscarClientes" :disabled="!btnAgregarCliente">
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="editedItem.clienteNombre"
                        label="Nombre Completo"
                        outlined dense hide-details
                        readonly
                        placeholder="Sin cliente (Tiquete simplificado)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 2: LÍNEAS DE DETALLE -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <div class="d-flex align-center w-100">
                    <v-icon color="primary" left class="mr-2">mdi-format-list-bulleted</v-icon>
                    Detalle del Tiquete
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="btnAgregarArti"
                      color="success"
                      x-small
                      rounded
                      outlined
                      @click.stop="mostrarBuscarArticulos"
                      class="mr-4 px-3"
                    >
                      <v-icon left size="16">mdi-cart-plus</v-icon>
                      Añadir Artículo
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-0">

                  <v-data-table
                    :headers="headersDetalle"
                    :items="lineasDetalle"
                    hide-default-footer
                    class="modern-table border-light rounded-lg overflow-hidden edit-table"
                    :items-per-page="-1"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-text-field
                        v-model.number="item.cantidad"
                        outlined hide-details
                        class="compact-input"
                        @input="recalcularTotales"
                      ></v-text-field>
                    </template>
                    <template v-slot:[`item.montoStr`]="{ item }">
                      <span class="font-weight-medium text-subtitle-1">{{ item.montoStr || (item.monto).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
                    </template>
                    <template v-slot:[`item.porcDescuento`]="{ item }">
                      <v-text-field
                        v-model.number="item.porcDescuento"
                        outlined hide-details
                        class="compact-input"
                        @input="recalcularTotales"
                      ></v-text-field>
                    </template>
                    <template v-slot:[`item.totalLineaStr`]="{ item }">
                      <span class="font-weight-medium text-subtitle-1">{{ item.totalLineaStr || (item.cantidad * item.monto).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                      <v-btn icon small color="primary" @click="detalleEditItem(item)" v-if="guardarValid">
                        <v-icon small>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                      <v-btn icon small color="error" @click="deleteItem(item)" v-if="guardarValid">
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 3: RESUMEN Y TOTALES -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-calculator-variant-outline</v-icon>
                  Resumen de Totales
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-xl pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Subtotal</div>
                        <div class="text-body-2 font-weight-bold">{{ editedItem.subtotalStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-xl pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Descuentos</div>
                        <div class="text-body-2 font-weight-bold error--text">{{ editedItem.totalDescuentosStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-xl pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Impuestos</div>
                        <div class="text-body-2 font-weight-bold primary--text">{{ editedItem.totalImpuestoStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-xl pa-2 primary border-light text-center white--text shadow-primary">
                        <div class="caption opacity-80 mb-0">TOTAL TIQUETE</div>
                        <div class="text-body-2 font-weight-black">{{ editedItem.totalComprobanteStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2 border-top-light pt-2" dense>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva1Str" label="IVA 1%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva2Str" label="IVA 2%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva4Str" label="IVA 4%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva13Str" label="IVA 13%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                       <v-text-field v-model="editedItem.totalIVADevueltoStr" label="IVA Devuelto" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 4: HACIENDA Y ACCIONES -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <div class="d-flex align-center" style="width:100%">
                    <v-icon color="primary" left class="mr-2">mdi-cloud-check-outline</v-icon>
                    Estado y Gestión Hacienda
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="editedItem.estadoHacienda"
                      :color="getEstadoColor(editedItem.estadoHacienda)"
                      dark x-small
                      class="font-weight-bold mr-2"
                    >
                      {{ editedItem.estadoHacienda }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense align="start">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="editedItem.clavehacienda"
                        label="Clave de Comprobante"
                        readonly outlined dense hide-details
                        :background-color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex align-center">
                       <v-btn
                        color="primary"
                        depressed
                        block
                        height="40"
                        @click="consultarEstadoHacienda"
                        :disabled="!consultarEstadoValid || visibleProgress"
                        :loading="visibleProgress"
                        class="font-weight-bold te-btn"
                      >
                        <v-icon left>mdi-sync</v-icon>
                        Consultar Estado
                      </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="editedItem.estadoHacienda" class="mt-2">
                       <div class="d-flex align-center pa-2 rounded-lg bg-light border-light">
                         <v-icon :color="getEstadoColor(editedItem.estadoHacienda)" class="mr-2">mdi-information-outline</v-icon>
                         <span class="font-weight-bold mr-2">Estado:</span>
                         <v-chip dark small :color="getEstadoColor(editedItem.estadoHacienda)" class="font-weight-black">
                           {{ editedItem.estadoHacienda }}
                         </v-chip>
                       </div>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="editedItem.mensajeHacienda"
                        label="Respuesta de Hacienda"
                        readonly outlined rows="2"
                        class="mt-2"
                        hide-details
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row v-if="editedIndex > -1" class="border-top-light pt-4 px-2" justify="center" dense>
                    <v-col cols="auto">
                      <v-btn text color="primary" class="rounded-pill" @click="getReport" :disabled="!verPDF">
                        <v-icon left>mdi-file-pdf-box</v-icon> PDF
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn text color="primary" class="rounded-pill" @click="getTiqueteReport">
                        <v-icon left>mdi-printer</v-icon> Térmico
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn text color="primary" class="rounded-pill" @click="getXMLFirmado" :disabled="!verXMLFirmado">
                        <v-icon left>mdi-xml</v-icon> XML
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn text color="primary" class="rounded-pill" @click="getXMLRespuesta" :disabled="!verXMLRespuesta">
                        <v-icon left>mdi-message-reply-text</v-icon> Rpta. XML
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 5: CONFIGURACIÓN ADICIONAL -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-cog-outline</v-icon>
                  Parámetros de Emisión
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-select label="Moneda" v-model="editedItem.moneda" :items="monedas" item-text="md_nombre" item-value="md_codigo" @change="changeMonedas" outlined dense hide-details prepend-inner-icon="mdi-cash-multiple"></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="editedItem.tipoCambio" label="T. Cambio" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select label="Condición Venta" v-model="editedItem.condicionVenta" :items="condicionesVenta" item-text="descripcion" item-value="codigo" outlined dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select label="Medio de Pago" v-model="editedItem.medioPago" :items="mediosPago" item-text="descripcion" item-value="codigo" outlined dense hide-details></v-select>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="editedItem.codigoActividad"
                        :items="actividades"
                        item-text="descripcion"
                        item-value="codigo"
                        label="Actividad Económica del Emisor"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-briefcase-outline"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.ordenCompra" label="Orden de Compra #" outlined dense prepend-inner-icon="mdi-file-document-outline" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.observacion" label="Observaciones en tiquete" outlined rows="2" hide-details></v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="te-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'te-drawer-footer--dark' : ''">
          <v-btn v-if="reenviarValid" color="secondary" text class="te-btn font-weight-bold" @click="reenviar">
            <v-icon left small>mdi-send-outline</v-icon> Reenviar Tiquete
          </v-btn>
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold te-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold te-btn" :loading="visibleProgress" @click="save" :disabled="!guardarValid">
            {{ editedIndex === -1 ? 'GENERAR TIQUETE' : 'GUARDAR CAMBIOS' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- VISOR DE DOCUMENTOS (PDF / XML) -->
    <v-dialog v-model="docViewerDialog" max-width="1100" eager>
      <v-card style="height: 88vh;" class="d-flex flex-column overflow-hidden rounded-xl">
        <div class="doc-viewer-toolbar d-flex align-center px-3 py-2 white--text flex-shrink-0">
          <v-icon color="white" size="18" class="mr-2">mdi-file-document-outline</v-icon>
          <span class="font-weight-bold text-subtitle-2">{{ docViewerTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small dark class="mr-1" @click="abrirEnNuevaPestana" title="Abrir en nueva pestaña">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon x-small dark @click="docViewerDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe v-if="docViewerDialog" :src="docViewerUrl" class="flex-grow-1" style="border: none; width: 100%;"></iframe>
      </v-card>
    </v-dialog>

    <!-- MODALES DE BÚSQUEDA -->
    <v-dialog transition="dialog-bottom-transition" v-model="dialog" width="900" persistent>
      <div v-if="showNewData">
        <BuscarClientes v-bind:allwedOnly="true" @clicked="selected" @closed="closed" />
      </div>
    </v-dialog>

    <v-dialog transition="dialog-bottom-transition" v-model="dialogBuscarArticulos" width="1000" persistent>
      <div v-if="showNewDataArti">
        <BuscarArticulos v-bind:allwedOnly="true" @clicked="selectedArticulos" @closed="closed" />
      </div>
    </v-dialog>

    <!-- MODAL DETALLE ARTÍCULO (TABLET-LIKE EDITOR) -->
    <v-dialog v-model="dialogArticulos" max-width="700px" persistent>
      <v-card flat class="overflow-hidden">
        <div class="te-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'te-drawer-header--dark' : ''">
           <v-icon color="white" class="mr-3">mdi-cart-edit</v-icon>
           <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">{{ formTitle }}</div>
           <v-spacer></v-spacer>
           <v-btn icon dark small @click="dialogArticulos = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6 mt-2">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.articulo" label="Código" outlined dense readonly hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="detalleEditedItem.descripcion" label="Descripción" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.cantidad" label="Cantidad" type="number" outlined dense hide-details step="any" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.monto" label="Precio Unit." type="number" outlined dense hide-details step="any" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.porcDescuento" label="% Descuento" type="number" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12">
               <v-text-field v-model="detalleEditedItem.cabys" label="Código CABYS" outlined dense readonly hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="detalleEditedItem.registroMedicamento" label="Reg. Medicamento" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-model="detalleEditedItem.formaFarmaceutica" item-text="descripcion" item-value="codigo" label="Forma Farmacéutica" outlined dense hide-details></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <div class="te-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'te-drawer-footer--dark' : ''">
          <v-spacer></v-spacer>
          <v-btn text class="mr-3 font-weight-bold te-btn" @click="dialogArticulos = false">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold te-btn" @click="saveDetalleArticulo">Aceptar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- OTROS DIALOGOS -->
    <v-dialog transition="dialog-bottom-transition" v-model="dialogSinpe">
      <div v-if="showNewData"><PagoSinpe v-bind:allwedOnly="true" v-bind:pagoInfo="pagoInfo" @closed="closed" /></div>
    </v-dialog>

    <v-dialog transition="dialog-bottom-transition" v-model="dialogReport" max-width="400">
      <div v-if="showNewData">
        <TiqueteReport v-bind:allwedOnly="true" v-bind:tiqueteInfo="tiqueteInfo" @clicked="closed2" @closed2="closed2" />
      </div>
    </v-dialog>

    <!-- MODAL REENVÍO POR CORREO -->
    <v-dialog v-model="dialogFormaReenvio" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <div class="secondary pa-6 white--text d-flex align-center">
           <v-icon color="white" class="mr-3">mdi-email-send-outline</v-icon>
           <h3 class="text-h6 font-weight-bold">Reenviar Comprobante</h3>
           <v-spacer></v-spacer>
           <v-btn icon dark @click="dialogFormaReenvio = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6 mt-4">
          <p class="body-1 mb-4">Confirme o edite el correo electrónico para el reenvío:</p>
          <v-text-field
            v-model="reenvioInfo.correo"
            label="Correo Electrónico"
            outlined
            dense
            rounded
            prepend-inner-icon="mdi-email-outline"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text rounded class="px-6" @click="dialogFormaReenvio = false">Cancelar</v-btn>
          <v-btn color="secondary" rounded depressed class="px-8 font-weight-bold" @click="confirmarReenvio">
            Enviar Ahora
            <v-icon right small>mdi-send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card class="rounded-xl pa-2">
        <v-card-title class="text-h6 font-weight-bold">¿Eliminar línea?</v-card-title>
        <v-card-text class="body-1 py-4">¿Estás seguro de que deseas descartar este artículo del tiquete?</v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn text rounded class="px-6" @click="closeDelete">Cancelar</v-btn>
          <v-btn color="error" rounded depressed class="px-6 font-weight-bold" @click="deleteItemConfirm">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import BuscarClientes from "./BuscarClientes.vue";
import BuscarArticulos from "./BuscarArticulos.vue";
import PagoSinpe from "./PagoSinpe.vue";
import TiqueteReport from "./TiqueteReport.vue";

export default {
  components: {
    Snackbar,
    BuscarClientes,
    BuscarArticulos,
    PagoSinpe,
    TiqueteReport,
  },
  data() {
    return {
      btnAgregarCliente: false,
      btnAgregarArti: false,
      iconVisible: false,
      iconVisibleCedula: false,
      visibleBtnConsultar: true,
      visibleProgress: false,
      dialogSinpe: false,
      dialogFormaReenvio: false,
      drawerForm: false, // NEW
      activePanels: [0], // NEW
      dialog: false,
      dialogArticulos: false,
      valid: false,
      incluirValid: true,
      consultarEstadoValid: false,
      cancelarValid: false,
      reenviarValid: false,
      imprimirValid: false,
      docViewerDialog: false,
      docViewerUrl: '',
      docViewerTitle: '',
      guardarValid: false,
      loading: false, // NEW
      search: "",
      snackText: "",
      snackValue: false,
      tab2: 1,
      tabFactura: 0,
      dialogDelete: false,
      dialogReport: false,
      verPDF: false,
      verXMLFirmado: false,
      verXMLRespuesta: false,
      dateModal: false,
      dates: [],
      panel: [0],
      panelResumen: [],
      licenciaValida: [],
      headers: [
        { text: "Código", align: "start", value: "codigoFact" },
        { text: "Cliente", align: "start", value: "clienteNombre" },
        { text: "Fecha", align: "start", value: "fechaString" },
        { text: "Clave", align: "start", value: "clavehacienda" },
        { text: "Estado", align: "center", value: "estadoHacienda" },
        { text: "Total", align: "end", value: "totalComprobante" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ],
      headersDetalle: [
        { text: "Articulo", value: "articulo", class: "bg-light primary--text font-weight-bold" },
        { text: "Descripción", value: "descripcion", class: "bg-light primary--text font-weight-bold" },
        { text: "Cantidad", value: "cantidad", width: "100px", class: "bg-light primary--text font-weight-bold" },
        { text: "Precio", value: "montoStr", class: "bg-light primary--text font-weight-bold" },
        { text: "% Desc.", value: "porcDescuento", width: "90px", class: "bg-light primary--text font-weight-bold" },
        { text: "Total", value: "totalLineaStr", align: "end", class: "bg-light primary--text font-weight-bold" },
        { text: "", value: "edit", sortable: false, width: "50px", class: "bg-light primary--text font-weight-bold" },
        { text: "", value: "delete", sortable: false, width: "50px", class: "bg-light primary--text font-weight-bold" },
      ],
      items: [],
      tiposIdentificacion: [],
      actividades: [],
      actividadesCliente: [],
      condicionesVenta: [],
      mediosPago: [],
      sucursales: [],
      terminales: [],
      monedas: [],
      provincias: [],
      cantones: [],
      distritos: [],
      barrios: [],
      cliente: [],
      articulo: [],
      totales: [],
      lineasDetalle: [],
      tipoCambio: [],
      respuestaHacienda: [],
      comprobante: [],
      editedIndex: -1,
      modelFactura: {
        comprobante: [],
        comprobanteDetalle: [],
      },
      editedItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "04",
        fecha: new Date().toISOString().slice(0, 10),
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "",
        medioPago: "",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: new Date(),
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        clienteCodigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "",
        nombreTabla: "Tiquetes",
        contingenciaFact: "",
        contingenciaFecha: null,
      },
      defaultItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "04",
        fecha: new Date(),
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "",
        medioPago: "",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: new Date(),
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        clienteCodigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "",
        nombreTabla: "Tiquetes",
        contingenciaFact: "",
        contingenciaFecha: null,
      },
      detalleditedIndex: -1,
      detalleEditedItem: {
        cia: "",
        factura: "",
        tipoFact: "04",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "01",
        unidadMedidaComercial: "M2",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
        cant_Dev: 0,
        linea_Dev: 0,
        clienteCod: "",
        clienteCedula: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
      },
      detalleDefaultItem: {
        cia: "",
        factura: "",
        tipoFact: "04",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "01",
        unidadMedidaComercial: "M2",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
        cant_Dev: 0,
        linea_Dev: 0,
        clienteCod: "",
        clienteCedula: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
      },
      pagoInfo: {
        sucursal: "",
        terminal: "",
        total: 0,
      },
      reenvioInfo: {
        numero: "",
        correo: "",
        porwhatsapp: false,
        porcorreo: false,
      },
      tiqueteInfo: {
        idTiquete: "",
        tipoTiquete: "",
      },
      opcionesSistemaCia: [],
      showNewData: false,
      showNewDataArti: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      tempFile: "",
      modelFile: null,
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    datesFormat() {
      return this.dates.join(" ~ ");
    },
    formTitle() {
      return this.detalleditedIndex === -1 ? "Nuevo Artículo" : "Editar Artículo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogArticulos(val) {
      val || this.close();
    },
    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.setDates();
    this.getData();
    this.getMonedas();
    this.getProvincias();
    this.getActividades();
    this.getCondicionVenta();
    this.getMedioPago();
    this.getOpcionesSistemaCia();
  },

  methods: {
    getData() {
      let me = this;
      me.loading = true;
      axios
        .get(
          "api/Facturacion/GetComprobantes?cia=" +
          this.strCia +
          "&docNombre=Tiquetes&tipoDoc=04" +
          "&fechaInicio=" +
          this.dates[0].toString() +
          "&fechaFin=" +
          this.dates[1].toString()
        )
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => me.loading = false);
    },

    getActividades() {
      let me = this;
      axios
        .get("api/General/getActividadesByCia?cia=" + this.strCia)
        .then(function (response) {
          me.actividades = response.data;
        });
    },

    setDates() {
      var date = new Date();
      var dateInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.dates = [
        dateInicio.toISOString().substr(0, 10),
        date.toISOString().substr(0, 10)
      ];
    },

    getEstadoColor(estado) {
      if (!estado) return "grey";
      const e = estado.toUpperCase();
      if (e === "ACEPTADO") return "success";
      if (e === "RECHAZADO") return "error";
      if (e === "PROCESANDO") return "warning";
      if (e === "PENDIENTE") return "info";
      return "grey";
    },

    recalcularTotales() {
      let me = this;
      // Asegurar que todas las líneas tengan los datos del cliente actual para el cálculo
      this.lineasDetalle.forEach(l => {
        l.clienteCod = this.editedItem.clienteCod;
        l.clienteCedula = this.editedItem.clienteCedula;
        l.moneda = this.editedItem.moneda;
      });
      axios
        .post("api/Facturacion/realizarCalculosComprobante", this.lineasDetalle)
        .then(function (response) {
          me.lineasDetalle = response.data.comprobanteDetalle;
          const t = response.data.comprobante;
          me.totales = t;
          
          Object.assign(me.editedItem, {
            subTotal: t.subtotal,
            totalDescuentos: t.totalDescuentos,
            totalImpuesto: t.totalImpuesto,
            totalIva1: t.totalIva1,
            totalIva2: t.totalIva2,
            totalIva4: t.totalIva4,
            totalIva8: t.totalIva8,
            totalIva13: t.totalIva13,
            totalComprobante: t.totalComprobante,
            totalIVADevuelto: t.totalIVADevuelto,
            totalServGravados: t.totalServGravados,
            totalServExentos: t.totalServExentos,
            totalServExonerado: t.totalServExonerado,
            totalMercanciasGravadas: t.totalMercanciasGravadas,
            totalMercanciasExentas: t.totalMercanciasExentas,
            totalMercExonerada: t.totalMercExonerada,
            totalGravado: t.totalGravado,
            totalExento: t.totalExento,
            totalExonerado: t.totalExonerado,
            totalVenta: t.totalVenta,
            totalVentaNeta: t.totalVentaNeta,
            totalOtrosCargos: t.totalOtrosCargos,
            
            subtotalStr: t.subtotalStr,
            totalDescuentosStr: t.totalDescuentosStr,
            totalImpuestoStr: t.totalImpuestoStr,
            totalComprobanteStr: t.totalComprobanteStr,
            totalIva1Str: t.totalIva1Str,
            totalIva2Str: t.totalIva2Str,
            totalIva4Str: t.totalIva4Str,
            totalIva13Str: t.totalIva13Str,
            totalIVADevueltoStr: t.totalIVADevueltoStr
          });
        });
    },

    editItem(item) {
      this.snackValue = false;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.getModeloComprobante();
      this.editedItem.nombreTabla = "Tiquetes";
      this.getCia();
      this.getMonedas();
      this.getActividades();
      this.getCondicionVenta();
      this.getMedioPago();
      this.getSucursales();
      this.drawerForm = true;
      this.activePanels = [0, 1, 2, 3];

      if (this.editedItem.estadoHacienda === "ACEPTADO" || this.editedItem.estadoHacienda === "RECHAZADO") {
        this.verPDF = true;
        this.verXMLFirmado = true;
        this.verXMLRespuesta = true;
        this.reenviarValid = true;
      } else {
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.reenviarValid = false;
      }

      this.guardarValid = false;
      this.incluirValid = true;
      if (this.editedItem.estadoHacienda === "PROCESANDO") {
        this.consultarEstadoValid = true;
      }
    },

    validarLicencia() {
      // Logic from old incluir part
      this.incluir();
    },

    incluir() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.lineasDetalle = [];
      this.drawerForm = true;
      this.activePanels = [0, 1, 2, 3];
      this.guardarValid = true;
      this.incluirValid = false;
      this.btnAgregarCliente = true;
      this.btnAgregarArti = true;
      
      // Defaults para Tiquete
      this.editedItem.condicionVenta = "01"; // Contado
      this.editedItem.medioPago = "01";       // Efectivo
      this.editedItem.tipoFact = "04";       // Tiquete
      this.editedItem.moneda = "CRC";        // Safe default
      this.editedItem.nombreTabla = "Tiquetes";
      
      this.getCia(); // Cargar moneda, sucursal, terminal y actividad de la cia
      this.getCodigoFactura(); // Cargar prefix T-
      
      this.editedItem.clienteCod = "CL-00001";
      this.BuscarClienteCodigo();
    },

    cerrar() {
      this.drawerForm = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.dialogBuscarArticulos = false;
      this.dialogFormaReenvio = false;
      this.actividadesCliente = [];
    },

    close() {
      this.dialogArticulos = false;
    },

    save() {
      if (!this.editedItem.clienteCod || this.lineasDetalle.length === 0) {
        this.snackText = "Complete el cliente y agregue artículos";
        this.snackValue = true;
        return;
      }
      let me = this;
      this.visibleProgress = true;
      
      const now = new Date();
      this.editedItem.fecha = now;
      this.editedItem.fechaHacienda = now;
      
      // Garantizar que contingenciaFecha siempre tenga un valor válido para el backend (.NET DateTime)
      if (!this.editedItem.contingenciaFecha) {
        this.editedItem.contingenciaFecha = now;
      }

      this.editedItem.cia = this.strCia;
      this.editedItem.usuario = this.user.id;
      this.editedItem.nombreTabla = "Tiquetes";
      this.editedItem.tipoFact = "04";

      // Asegurar sucursal y terminal si por alguna razón siguen vacíos
      if (!this.editedItem.sucursal && this.sucursales.length > 0) {
        this.editedItem.sucursal = this.sucursales[0].sucursalId;
      }

      // Asegurar moneda si por alguna razón sigue vacía
      if (!this.editedItem.moneda) {
        this.editedItem.moneda = "CRC";
      }

      this.modelFactura.comprobante = this.editedItem;
      this.modelFactura.comprobanteDetalle = this.lineasDetalle;

      axios
        .post("api/Facturacion/insertComprobante", this.modelFactura)
        .then(function (response) {
          me.visibleProgress = false;
          me.respuestaHacienda = response.data;
          me.editedItem.clavehacienda = me.respuestaHacienda.claveHacienda;
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;

          if (me.editedItem.estadoHacienda === "PROCESANDO") {
            me.consultarEstadoValid = true;
          }
          me.getData();
          me.drawerForm = false;
        })
        .catch(function (error) {
          console.log(error);
          me.visibleProgress = false;
        });
    },

    consultarEstadoHacienda() {
      this.editedItem.nombreTabla = "Tiquetes";
      this.visibleProgress = true;
      let me = this;
      axios
        .post("api/Facturacion/obtenerRespuestaHacienda", this.editedItem)
        .then(function (response) {
          me.respuestaHacienda = response.data;
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;
          me.visibleProgress = false;
          if (me.editedItem.estadoHacienda !== "PROCESANDO") {
            me.consultarEstadoValid = false;
          }
          me.getData();
        })
        .catch(function (error) {
          console.log(error);
          me.visibleProgress = false;
        });
    },

    getActividadesCliente(cedulaCliente) {
      if (!cedulaCliente) return;
      let me = this;
      axios.get(`api/Clientes/getActividadesByCliente?cedulaCia=${this.strCia}&cedulaCliente=${cedulaCliente}`)
        .then(res => {
          me.actividadesCliente = res.data;
          if (res.data && res.data.length > 0) {
            if (!me.editedItem.clienteCodigoActividad) {
              const defecto = res.data.find(a => a.esDefecto) || res.data[0];
              me.editedItem.clienteCodigoActividad = defecto.codigo;
            }
          } else {
            me.editedItem.clienteCodigoActividad = "";
          }
        });
    },

    BuscarClienteCodigo() {
      let me = this;
      if (me.editedItem.clienteCod !== "") {
        axios
          .get("api/Clientes/getCliente?cia=" + this.strCia + "&codigo=" + this.editedItem.clienteCod)
          .then(function (response) {
            me.cliente = response.data;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clientecorreo = me.cliente.correo;
            me.editedItem.clienteCorreo = me.cliente.correo;

            // Actualizar líneas si ya existen
            me.lineasDetalle.forEach(l => {
              l.clienteCod = me.editedItem.clienteCod;
              l.clienteCedula = me.editedItem.clienteCedula;
            });
            me.getActividadesCliente(me.cliente.cedula);
          });
      }
    },

    BuscarClienteCedula() {
      let me = this;
      if (me.editedItem.clienteCedula !== "") {
        axios
          .get("api/Clientes/getCliente?cia=" + this.strCia + "&cedula=" + this.editedItem.clienteCedula)
          .then(function (response) {
            me.cliente = response.data;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clientecorreo = me.cliente.correo;
            me.editedItem.clienteCorreo = me.cliente.correo;

            // Actualizar líneas si ya existen
            me.lineasDetalle.forEach(l => {
              l.clienteCod = me.editedItem.clienteCod;
              l.clienteCedula = me.editedItem.clienteCedula;
            });
            me.getActividadesCliente(me.cliente.cedula);
          });
      }
    },

    selected(value) {
      this.cliente = Object.assign({}, value);
      this.editedItem.clienteCod = this.cliente.codigo;
      this.editedItem.clienteNombre = this.cliente.nombre;
      this.editedItem.clienteCedula = this.cliente.cedula;
      this.editedItem.clientecorreo = this.cliente.correo;
      this.editedItem.clienteCorreo = this.cliente.correo;

      // Actualizar líneas existentes con el nuevo cliente
      this.lineasDetalle.forEach(l => {
        l.clienteCod = this.editedItem.clienteCod;
        l.clienteCedula = this.editedItem.clienteCedula;
      });

      this.getActividadesCliente(this.cliente.cedula);
      this.dialog = false;
      this.showNewData = false;
    },

    selectedArticulos(value) {
      this.articulo = Object.assign({}, value);
      this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
      this.detalleEditedItem.articulo = this.articulo.codigo;
      this.detalleEditedItem.descripcion = this.articulo.nombre;
      this.detalleEditedItem.unidad = this.articulo.unidad || "Unid";
      this.detalleEditedItem.monto = this.articulo.monto;
      this.detalleEditedItem.cantidad = 1;
      this.detalleEditedItem.impCodigo = this.articulo.codigoImp;
      this.detalleEditedItem.impCodigoTarifa = this.articulo.codigoTarifa;
      this.detalleEditedItem.impTarifa = this.articulo.tarifa;
      this.detalleEditedItem.impuestosVentas = this.articulo.tarifa; // CRITICAL for backend calculation
      this.detalleEditedItem.impuestoNeto = 0;
      this.detalleEditedItem.cabys = this.articulo.cabys;
      this.detalleEditedItem.tipoProducto = this.articulo.tipoProducto || "02"; // 01=Serv, 02=Merc (Necessary for summary calculation)
      this.detalleEditedItem.tipoFact = "04";
      this.detalleEditedItem.cia = this.strCia;
      this.detalleEditedItem.clienteCod = this.editedItem.clienteCod;
      this.detalleEditedItem.clienteCedula = this.editedItem.clienteCedula;
      this.detalleEditedItem.sucursal = this.editedItem.sucursal;
      this.detalleEditedItem.terminal = this.editedItem.terminal;
      this.detalleEditedItem.tipoCodigo = "01";
      this.detalleEditedItem.unidadMedidaComercial = "M2";
      this.detalleEditedItem.moneda = this.editedItem.moneda || "CRC";

      this.lineasDetalle.push(this.detalleEditedItem);
      this.dialogBuscarArticulos = false;
      this.showNewDataArti = false;
      this.recalcularTotales();
      
      if (!this.activePanels.includes(1)) {
        this.activePanels.push(1);
      }
    },

    saveDetalleArticulo() {
      this.dialogArticulos = false;
      this.recalcularTotales();
    },

    deleteItem(item) {
      const index = this.lineasDetalle.indexOf(item);
      if (index > -1) {
        this.lineasDetalle.splice(index, 1);
        this.recalcularTotales();
      }
    },

    mostrarBuscarClientes() {
      this.showNewData = true;
      this.dialog = true;
    },

    mostrarBuscarArticulos() {
      this.showNewDataArti = true;
      this.dialogBuscarArticulos = true;
    },

    confirmarReenvio() {
      this.visibleProgress = true;
      let me = this;
      this.editedItem.clientecorreo = this.reenvioInfo.correo;
      axios.post("api/Facturacion/reenviarCorreo", this.editedItem)
        .then(function (response) {
          me.snackText = response.data;
          me.snackValue = true;
          me.dialogFormaReenvio = false;
        })
        .finally(() => me.visibleProgress = false);
    },

    reenviar() {
      this.reenvioInfo.correo = this.editedItem.clientecorreo;
      this.dialogFormaReenvio = true;
    },

    openDocViewer(url, title) {
      this.docViewerUrl = url;
      this.docViewerTitle = title;
      this.docViewerDialog = true;
    },

    abrirEnNuevaPestana() {
      window.open(this.docViewerUrl, '_blank');
    },

    getReport() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=pdf`,
        "PDF — Tiquete Electrónico"
      );
    },

    getTiqueteReport() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=thermal`,
        "Tiquete Térmico"
      );
    },

    getXMLFirmado() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=signed`,
        "XML Enviado — Tiquete Electrónico"
      );
    },

    getXMLRespuesta() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=response`,
        "Respuesta XML — Tiquete Electrónico"
      );
    },

    getModeloComprobante() {
      let me = this;
      axios.get("api/Facturacion/getModeloComprobanteByCodigoFactura?cia=" + this.strCia + "&codigoFact=" + this.editedItem.codigoFact + "&docNombre=Tiquetes")
        .then(function (response) {
          me.editedItem = response.data.comprobante;
          me.lineasDetalle = response.data.comprobanteDetalle;
        });
    },

    getMonedas() {
      let me = this;
      axios.get("api/General/getMonedas").then(function (response) { me.monedas = response.data; });
    },

    getCondicionVenta() {
      let me = this;
      axios.get("api/General/getCondicionVenta").then(function (response) { me.condicionesVenta = response.data; });
    },

    getMedioPago() {
      let me = this;
      axios.get("api/General/getMedioPago").then(function (response) { me.mediosPago = response.data; });
    },

    getSucursales() {
      let me = this;
      axios.get("api/Cias/getSucursalesByCia?cia=" + this.strCia).then(function (response) { me.sucursales = response.data; });
    },

    getTerminales(sucursal) {
      let me = this;
      axios.get(`api/Cias/getTerminales?cia=${this.strCia}&sucursal=${sucursal}`)
        .then(res => {
          me.terminales = res.data;
          if (!me.editedItem.terminal && me.terminales.length > 0) {
            me.editedItem.terminal = me.terminales[0].terminalId;
          }
        });
    },

    getProvincias() {
      let me = this;
      axios.get("api/General/getProvincias").then(function (response) { me.provincias = response.data; });
    },

    getOpcionesSistemaCia() {
      let me = this;
      axios.get("api/General/getOpcionesSistemaCia?cia=" + this.strCia).then(function (response) { me.opcionesSistemaCia = response.data; });
    },

    getCia() {
      let me = this;
      axios.get("api/Cias/getCia?ciaId=" + this.strCia)
        .then(res => {
          const cia = res.data;
          me.editedItem.emisorNombre = cia.nombre;
          me.editedItem.emisorNombreComercial = cia.nombreComercial;
          me.editedItem.codigoActividad = cia.codigoActividad;
          me.editedItem.emisorTelefono = cia.telefono;
          me.editedItem.emisorCorreo = cia.correo;
          me.editedItem.emisorDireccion = cia.direccion;
          me.editedItem.moneda = cia.moneda;
          me.editedItem.sucursal = cia.sucursal;
          me.editedItem.terminal = cia.terminal;
          me.editedItem.emisorCedula = cia.cedula;
          me.editedItem.emisorTipoId = cia.tipoId;
          
          // Ubicación emisor para XML
          me.editedItem.emisorProvincia = cia.provincia;
          me.editedItem.emisorCanton = cia.canton;
          me.editedItem.emisorDistrito = cia.distrito;
          me.editedItem.emisorBarrio = cia.barrio;

          if (cia.sucursal) {
            me.getTerminales(cia.sucursal);
          }
        });
    },

    getCodigoFactura() {
      let me = this;
      axios.get(`api/Facturacion/getComprobanteConsInterno?cia=${this.strCia}&docNombre=Tiquetes&tipoDoc=T`)
        .then(res => me.editedItem.codigoFact = res.data);
    },

    closed() {
      this.cerrar();
    }
  },
};
</script>

<style scoped>
/* === TE DESIGN SYSTEM === */
.te-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.te-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.te-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}
.te-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}
.te-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

/* Tabla principal */
.te-table { background: transparent !important; }
.te-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.te-table >>> tbody tr { cursor: pointer; }
.te-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .te-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* Search inputs */
.te-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* Drawer */
.te-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .te-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}
.te-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.te-drawer-header--dark {
  background-color: #263238 !important;
}
.te-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.te-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* Tabla de detalle */
.modern-table { background: transparent !important; }
.detail-table-modern { background: transparent !important; }
.modern-table >>> thead th,
.detail-table-modern >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
  height: 40px !important;
}
.modern-table >>> tbody td,
.detail-table-modern >>> tbody td {
  border-bottom: 1px solid #f1f5f9 !important;
  height: 40px !important;
}
.theme--dark .modern-table >>> thead th,
.theme--dark .detail-table-modern >>> thead th {
  background-color: #263238 !important;
  color: #cfd8dc !important;
}
.theme--dark .modern-table >>> tbody td,
.theme--dark .detail-table-modern >>> tbody td {
  border-bottom: 1px solid #334155 !important;
}

/* Expansion panels */
.modern-panels >>> .v-expansion-panel { border: 1px solid rgba(0,0,0,0.07) !important; border-radius: 4px !important; }
.theme--dark .modern-panels >>> .v-expansion-panel { border: 1px solid rgba(255,255,255,0.07) !important; }
.modern-panels >>> .v-expansion-panel--active {
  border: 1px solid rgba(55, 71, 79, 0.3) !important;
  box-shadow: 0 4px 12px rgba(55, 71, 79, 0.07) !important;
  margin-bottom: 2px !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel + .v-expansion-panel { margin-top: 2px !important; }
.modern-panels >>> .v-expansion-panel-header {
  min-height: 40px !important;
  padding: 0 12px !important;
  font-size: 0.875rem !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel-content__wrap { padding: 4px 4px 6px !important; }

/* Inputs compactos en tabla detalle */
.compact-input >>> input {
  padding: 0px !important;
  text-align: center !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  height: 28px !important;
  min-width: 40px !important;
  max-width: 60px !important;
}
.compact-input >>> .v-input__slot { padding: 0 4px !important; border-radius: 4px !important; min-height: 28px !important; }
.compact-input >>> .v-input__control { min-height: 38px !important; }
.compact-input >>> input::-webkit-outer-spin-button,
.compact-input >>> input::-webkit-inner-spin-button { -webkit-appearance: none !important; margin: 0 !important; }
.theme--dark .compact-input >>> input { color: #ffffff !important; }
.theme--light .compact-input >>> input { color: #000000 !important; }
.right-input >>> input { text-align: right; font-weight: bold; }
.edit-table >>> td { height: 40px !important; }

/* Visor de documentos */
.doc-viewer-toolbar {
  background-color: #37474f;
  min-height: 44px;
  flex-shrink: 0;
}
</style>